import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import "../componentCss/webform.css";
import { useParams } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import Sidebar from "./sidebar";
import "../componentCss/sidebar.css";
import {
  getFormDetailsAction,
  insertFormDataAction,
  insertFormDataActionForSubForm,
  getPatientDataAction,
  getDraftDataAction,
  getLatestDraftAction,
  reAdmitDataAction
} from "../../Action/admin.action";
import toast from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import MyKonvaComponent from "./ModalComponents/MyKonvaComponent";
import FormSubmissionHistory from "./FormSubmissionHistory";
import FormTemplateManager from "./FormTemplateManager";
import propertise from "../../config/properties";
import { decryptData } from "./decrypt";
import config from "../../config/config";
let MRNNumber = "MRN" + (Math.floor(Math.random() * 900000) + 100000);


// Helper function to get field properties with backward compatibility
const getFieldProperty = (field, property) => {
  const propertyMap = {
    id: field.id || field.field_id,
    fieldName: field.fieldName || field.label,
    fieldtype: field.fieldtype || field.field_type,
    fieldTypeId: field.fieldTypeId || field.field_type_id,
    isMandatory: field.isMandatory || field.required,
    radioCheckboxValue: field.radioCheckboxValue || (field.options ? JSON.stringify(field.options) : null),
    dropdownFormId: field.dropdownFormId || field.dropdown_form_id,
    dropdownFieldId: field.dropdownFieldId || field.dropdown_field_id,
    fieldValue: field.fieldValue || field.default_value
  };
  
  return propertyMap[property] || field[property];
};

// Helper function to generate unique field key
const getFieldKey = (field, index) => {
  const baseId = field.id || field.field_id;
  return `${baseId}_${index}`;
};

// Helper to get field value with fallback to simple ID for backward compatibility
const getFieldValue = (field, index, draftData, formValues, draftDataList) => {
  const compositeKey = getFieldKey(field, index);
  const simpleKey = field.id || field.field_id;

  if (draftDataList.length > 0) {
    return draftData[compositeKey] ?? draftData[simpleKey] ?? '';
  } else {
    return formValues[compositeKey] ?? formValues[simpleKey] ?? '';
  }
};

const Webform = () => {
  let { formId, id, patientId } = useParams();
  let [formValues, setFormValues] = useState({});
  const [draftData, setDraftData] = useState([]);
  const [draftDataList, setDraftDataList] = useState([]);
  const [formDetails, setFormDetails] = useState([]);
  const [subFormValues, setSubFormValues] = useState([]);
  const [subFormDetails, setSubFormDetails] = useState([]);
  const [formPreviewValues, setFormPreviewValues] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [formDetailIdForForm, setFormDetailsId] = useState('')
  const [patientDetails, setPatientDetails] = useState({ emrNumber: '', mrnNumber: MRNNumber });
  const [stageRefs, setStageRefs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reAdmitData, setReAdmitData] = useState([]);

  // Template application callback
  const handleTemplateApply = (templateData) => {
    if (templateData && typeof templateData === 'object') {
      setFormValues(prev => ({
        ...prev,
        ...templateData
      }));
      toast.success('Template applied successfully');
    }
  };

  useEffect(() => {
    const refsArray = formDetails.map(() => React.createRef());
    setStageRefs(refsArray);
  }, [formDetails]);

  useEffect(() => {
    getFormDetailsAPI();
    getDraftDataAPI();
    getReAdmitData();

    if (patientId && patientId !== 'undefined') {
      getPatientDataAPI()
    }

  }, [patientId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Populate form values when both form details and draft data are available
  useEffect(() => {
    if (formDetails.length > 0 && Object.keys(draftData).length > 0) {
      setFormValues(draftData);
    }
  }, [formDetails, draftData]);

  let getDraftDataAPI = async () => {
    // First try to get the latest draft for this specific form and patient
    if (patientId && patientId !== 'undefined') {
      try {
        const latestDraftRes = await getLatestDraftAction(formId, patientId);
        if (latestDraftRes.success && latestDraftRes.data) {
          // Convert the draft data to the expected format
          const draftData = latestDraftRes.data.data || [];
          
          // Convert array format to object format for form population
          const convertedData = {};
          draftData.forEach(item => {
            convertedData[item.field_id] = item.value;
          });
          
          setDraftData(convertedData);
          setDraftDataList([convertedData]);
          // Also populate formValues with draft data for immediate display
          setFormValues(convertedData);
          console.log('Loaded latest draft for patient:', patientId);
          return;
        }
      } catch (error) {
        console.log('No latest draft found, trying legacy method');
      }
    }
    
    // Fallback to legacy method
    let res = await getDraftDataAction({ id: formId });
    if (res.success) {
      setDraftData(res.data[0]);
      setDraftDataList(res.data)
    }
  };

  let getPatientDataAPI = async () => {
    let res = await getPatientDataAction({ 'patientId': patientId, 'formId': propertise.patientAdmit });
    if (res.success) {
      let data = decryptData(res.data);
      setPatientDetails({
        ...patientDetails,
        emrNumber: data.emrNumber,
        mrnNumber: data.mrnNumber
      });
    }
  };

  let getFormDetailsAPI = async () => {
    let res = await getFormDetailsAction(formId);
    if (res.success) {
      const formData = decryptData(res.data);
      // Handle modern API response structure - extract fields array
      const fields = formData.fields || [];
      setFormDetails(Array.isArray(fields) ? fields : []);
    }
  };

  const handleChangeData = (e) => {
    const { name, value } = e.target;
    setPatientDetails({
      ...patientDetails,
      [name]: value,
    });
  };

  const getReAdmitData = async() => {
    const reAdmitData = new URLSearchParams(window.location.search);
    const data = reAdmitData.get('data');
    const reAdmitDataList = data ? JSON.parse(decodeURIComponent(data)) : {};
    setReAdmitData(reAdmitDataList)
  }

  const handleChange = async (e, item, index) => {
    let tempFormDetails = [...formDetails];
    let subFormData = [...subFormDetails];
    let tempSubFormValues = [...subFormValues];

    const { name, value, type, checked, id } = e.target;
    const fieldKey = name; // Already contains composite key from field rendering

    let newValue = "";
    let newValue1 = "";
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = e.target.files[0];
    } else if (name.includes("assignTo")) {
      const [id, ...firstNameParts] = e.target.value.split("_");
      const firstName = firstNameParts.join("_");

      newValue = id;
      newValue1 = firstName;
    } else {
      newValue = value;
    }

    if (type === "radio") {
      if (
        item.dropdownFormId > 0 &&
        (value.trim() === "Yes" ||
          value.trim() === "YES" ||
          value.trim() === "yes")
      ) {
        tempSubFormValues.push({
          subFormId: item.dropdownFormId,
          id,
          formDetailId: item.id,
        });
        setFormDetailsId(item.id)
        setSubFormValues(tempSubFormValues);
        let res = await getFormDetailsAction(item.dropdownFormId);
        if (res.success) {
          let resForm = tempFormDetails.find((data) => data.id === item.id);
          resForm.dropDownFormData = decryptData(res.data);
          let obj = decryptData(res.data);
          obj.dropdownFormId = item.dropdownFormId;
          setFormDetails(tempFormDetails);
          subFormData.push(obj);
          setSubFormDetails(subFormData);
        }
      } else {
        let resForm = tempFormDetails.find((data) => data.id === item.id);
        let getSubFormIndex = subFormDetails.findIndex(
          (data) => data.dropdownFormId === item.dropdownFormId
        );
        subFormDetails.splice(getSubFormIndex, 1);

        resForm.dropDownFormData = "";
        setFormDetails(tempFormDetails);
        setSubFormDetails(subFormDetails);
      }
    }
    if (draftDataList.length > 0) {
      setDraftData({ ...draftData, [fieldKey]: newValue })
    } else {
      setFormValues({ ...formValues, [fieldKey]: newValue });
    }

    setFormPreviewValues({
      ...formPreviewValues,
      [id]: newValue1 !== "" ? newValue1 : newValue,
    });
  };

  const handleChangeMRNNUmber = async (e, item) => {
    const { value } = e.target;
    setPatientDetails({
      ...patientDetails,
      mrnNumber: value
    });
  };

  const handleChangeForSubForm = async (e, formId, index) => {
    const { name, value, type, checked, id } = e.target;
    let newValue = "";
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = e.target.files[0];
    } else {
      newValue = value;
    }

    let getIndex = subFormValues.findIndex((data) => data.subFormId === formId);
    if (getIndex > -1) {
      const updatedForm = {
        ...subFormValues[getIndex],
        [name]: newValue,
        formDetailId: formDetailIdForForm,
        formId: formId,
        subFormId: formId,
      };
      const updatedSubFormValues = [...subFormValues];
      updatedSubFormValues[getIndex] = updatedForm;
      setSubFormValues(updatedSubFormValues);
      setFormPreviewValues({ ...formPreviewValues, [id]: newValue });
    }
  };

  const resetForm = async (e) => {
    e.preventDefault();
    setTimeout(() => {
      window.location.reload()
    },);
  }

  // Helper to convert form values to submission data array format
  const convertFormValuesToSubmissionData = (formData) => {
    const fieldMap = new Map();

    Object.entries(formData).forEach(([key, value]) => {
      const parts = key.split('_');
      const lastPart = parts[parts.length - 1];

      let fieldId;
      let hasIndex = false;

      // Check if key has an index suffix (e.g., fieldId_0)
      if (parts.length >= 2 && !isNaN(lastPart) && lastPart === parseInt(lastPart).toString()) {
        fieldId = parts.slice(0, -1).join('_');
        hasIndex = true;
      } else {
        fieldId = key;
      }

      // Prefer composite keys (with index) over simple keys to avoid duplicates
      if (!fieldMap.has(fieldId) || hasIndex) {
        fieldMap.set(fieldId, value);
      }
    });

    return Array.from(fieldMap.entries()).map(([field_id, value]) => ({
      field_id,
      value
    }));
  };

  const handleSubmit = async (e, submitType, redirectionType = 0) => {
    e.preventDefault();
    setIsLoading(true)

    // For FormData submission, keep composite keys to preserve all field values
    // (e.g., email_0, email_1 instead of losing data by converting to single 'email' key)
    let submissionData = {};
    if (draftDataList.length > 0) {
      submissionData = { ...draftData };
    } else {
      submissionData = { ...formValues };
    }

    submissionData.formId = formId;
    submissionData.referenceFormId = id;
    submissionData.pid = patientId;
    submissionData.submitType = submitType;
    submissionData.mrnNumber = patientDetails?.mrnNumber;
    submissionData.emrNumber = patientDetails?.emrNumber;
    submissionData.department_id = formDetails?.[0]?.department_id || null;
    submissionData.category_id = formDetails?.[0]?.category_id || null;
    submissionData.isEdit = 0;

    let res = await insertFormDataAction({ formValues: submissionData });
    if (res.success) {

      // Update sub form data
      if (subFormValues.length > 0) {
        await insertFormDataActionForSubForm({ subFormValues: subFormValues });
      }

      toast.success(res.msg);

      if (redirectionType === 1) {
        let patientid = res.data[0].id
        if (formId !== propertise.patientAdmit) {
          patientid = patientId
        }
        setTimeout(() => {
          window.location.href = `${config.baseUrl}form-submission/${formDetails[0].actionFormId}/0/${patientid}`
        }, 2000);
      } else {
        if (formId === 4) {
          setTimeout(() => {
            window.location.href = `${config.baseUrl}patient-records`
          }, 2000);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }
    } else {
      setIsLoading(false)
      toast.error(res.msg);
    }


  // Re-Admit Section:----
    
    let reAdmit = await reAdmitDataAction({ formValues: formValues });
    if (reAdmit.success) {
      toast.success(reAdmit.msg);
    } else {
      setIsLoading(false)
      toast.error(reAdmit.msg);
    }
  
  
  // End



  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handleSave = (e, index) => {
    e.preventDefault();
    const stageRef = stageRefs[index].current;
    const uri = stageRef.toDataURL();
    const file = dataURLtoFile(uri, `${stageRef.attrs.name}.png`);
    if (file) {
      toast.success('Image Saved..')
      setFormValues({ ...formValues, [stageRef.attrs.name]: file });
      setFormPreviewValues({
        ...formPreviewValues,
        [stageRef.attrs.id]: file
      });
    }
  };

  const formPreview = (e, index) => {
    e.preventDefault();
    setShowPreview(true);
  };

  const handleCancel = () => {
    setShowPreview(false);
  };

  function FormPreview({ formData, onCancel, onSubmit }) {
    const [imageUrls, setImageUrls] = useState({});
    useEffect(() => {
      const newImageUrls = {};
      Object.entries(formData).forEach(([key, value]) => {
        if (value instanceof File) {
          newImageUrls[key] = URL.createObjectURL(value);
          return () => URL.revokeObjectURL(newImageUrls[key]);
        }
      });
      setImageUrls(newImageUrls);
    }, [formData]);

    const getDisplayValue = (key, value) => {
      if (value instanceof File) {
        if (!imageUrls[key]) {
          const url = URL.createObjectURL(value);
          setImageUrls((prevUrls) => ({
            ...prevUrls,
            [key]: url,
          }));
          return url;
        }
        return imageUrls[key];
      }
      return value;
    };


    return (
      <div className="form-preview-container">
        <h2 className="text-center mb-4">Form Preview</h2>

        <div className="card shadow p-3 mb-5 bg-white rounded">
          <ul className="list-group list-group-flush">
            {draftDataList.length > 0 ? (
              Object.entries(draftData).map(([key, value]) => (
                <li key={key} className="list-group-item d-flex justify-content-between align-items-center">
                  <strong>{key}:</strong>
                  {(value instanceof File) ? (
                    <div>
                      <img
                        src={getDisplayValue(key, value)}
                        alt="Preview"
                        className="img-thumbnail"
                        style={{ maxWidth: "200px", height: "auto" }}
                      />
                    </div>
                  ) : (
                    <span>{getDisplayValue(key, value)}</span>
                  )}
                </li>
              ))
            ) : (
              formDetails.map((data, index) => {
                const fieldKey = getFieldKey(data, index);
                const fieldValue = getFieldValue(data, index, draftData, formValues, draftDataList);

                return fieldValue && (
                  <li key={fieldKey} className="list-group-item d-flex justify-content-between align-items-center">
                    <strong>{getFieldProperty(data, 'fieldName')}:</strong>
                    {(fieldValue instanceof File) ? (
                      <div>
                        <img
                          src={getDisplayValue(fieldKey, fieldValue)}
                          alt="Preview"
                          className="img-thumbnail"
                          style={{ maxWidth: "200px", height: "auto" }}
                        />
                      </div>
                    ) : (
                      <span>{getDisplayValue(fieldKey, fieldValue)}</span>
                    )}
                  </li>
                )
              })
            )}
          </ul>
        </div>

        <div className="button-container text-center">
          <button className="btn btn-secondary mt-3 me-2" onClick={onCancel}>
            Cancel
          </button>

          {formId === 4 &&
            <button disabled={isLoading === true ? true : false} className="btn btn-primary mt-3" onClick={(e) => handleSubmit(e, 1, 0)}>
              {isLoading === true ? 'Loading...' : 'Submit'}
            </button>
          }
          &nbsp;&nbsp;
          {formDetails[0].isCallToAction === 1 && (
            <button disabled={isLoading === true ? true : false} className="btn btn-primary mt-3" onClick={(e) => handleSubmit(e, 1, 1)}>
              {isLoading === true ? 'Loading...' : 'Submit & Redirect'}
            </button>
          )}
        </div>
      </div>
    );

  }

  return (
    <>
      <Dashboardheader />
      <div className="wrapper">
        <Sidebar />
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="innerhead mb-4">
                  <h5 className="headtitle">
                    {formDetails.length > 0 ? formDetails[0].formName : ""}
                  </h5>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="formDiv">
                  {!showPreview ? (
                    <>
                      <Form>
                        <Row className="mb-4">

                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3 fieldbox h-auto px-2">
                                <Form.Label>Emirates Id Number</Form.Label>
                                <Form.Control

                                  type="text"
                                  placeholder="Enter Emirates Id Number"
                                  className="form-control"
                                  name="emrNumber"
                                  readOnly={formId === propertise.patientAdmit ? false : true}
                                  onChange={handleChangeData}
                                  value={formId === 134 ? reAdmitData?.emrNumber :patientDetails?.emrNumber}
                                />
                              </Form.Group>
                            </Col><Col>
                              <Form.Group className="mb-3 fieldbox h-auto px-2">
                                <Form.Label>MRN Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter MRN Number"
                                  className="form-control"
                                  onChange={handleChangeMRNNUmber}
                                  name="mrnNumber"
                                  value={formId === 134 ? reAdmitData?.mrnNumber :patientDetails?.mrnNumber}
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          {formDetails.length > 0
                            ? formDetails.map((item, index) =>
                              (formId === 1 &&
                                (getFieldProperty(item, 'fieldName') === "emrNumber" || getFieldProperty(item, 'fieldName') === "Mrn Number" || getFieldProperty(item, 'fieldName') === "Patient Satus")) ? null : (
                                <Col
                                  xs={12}
                                  md={
                                    getFieldProperty(item, 'fieldTypeId') === 17 ||
                                    getFieldProperty(item, 'fieldtype') === "markdown"
                                      ? 12
                                      : 6
                                  }
                                  className="mt-3"
                                  key={getFieldProperty(item, 'id')}
                                >
                                  {item.fieldTypeId === 17 && (
                                    <Row>
                                      <Col lg={12} md={12} sm={12}>
                                        <div
                                          style={{
                                            background:
                                              "linear-gradient(268deg, #4B91CE 0%, #5A73B5 100%)",
                                            color: "white",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            textShadow:
                                              "2px 1px 4px rgba(0, 0, 0, 0.25)",
                                          }}
                                        >
                                          <span>{item.fieldName}</span>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  {/* Render markdown fields full-width (skip Form.Group wrapper) */}
                                  {getFieldProperty(item, 'fieldtype') === "markdown" && (
                                    <Row>
                                      <Col lg={12} md={12} sm={12}>
                                        <div className="markdown-field-container mb-3">
                                          <div className="markdown-content">
                                            <ReactMarkdown
                                              remarkPlugins={[remarkGfm]}
                                              components={{
                                                a: ({ node, ...props }) => (
                                                  <a {...props} target="_blank" rel="noopener noreferrer" />
                                                ),
                                                img: ({ node, ...props }) => (
                                                  <img {...props} style={{ maxWidth: '100%', height: 'auto' }} loading="lazy" />
                                                ),
                                              }}
                                            >
                                              {item.fieldName || item.label || ''}
                                            </ReactMarkdown>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  {item.fieldTypeId != 17 &&
                                   getFieldProperty(item, 'fieldtype') !== "markdown" && (
                                    <Form.Group
                                      as={Col}
                                      controlId="formGridEmail"
                                    >
                                      <label>
                                        {item.fieldtype !== "btn" && item.fieldtype !== "markdown" && item.field_type !== "markdown"
                                          ? item.fieldName
                                          : ""}
                                      </label>{" "}
                                      <br />
                                      {item.fieldtype === "select" ? (
                                        <select
                                          className="form-control"
                                          id={item.fieldName}
                                          name={getFieldKey(item, index)}
                                          data-field-id={item.id}
                                          onChange={(e) => handleChange(e, item, index)}
                                          value={getFieldValue(item, index, draftData, formValues, draftDataList)}
                                        >
                                          <option value={0}>
                                            Select Department
                                          </option>
                                          {item.dropdownValue != null
                                            ? JSON.parse(
                                              item.dropdownValue
                                            ).map((itemDropdown) => (
                                              <option
                                                key={itemDropdown.fieldValue}
                                                value={
                                                  itemDropdown.fieldValue
                                                }
                                              >
                                                {itemDropdown.fieldValue}
                                              </option>
                                            ))
                                            : ""}
                                        </select>
                                      ) :
                                        item.fieldtype === "selectManual" ? (
                                          <select
                                            className="form-control"
                                            id={item.fieldName}
                                            name={getFieldKey(item, index)}
                                            data-field-id={item.id}
                                            onChange={(e) => handleChange(e, item, index)}
                                            value={getFieldValue(item, index, draftData, formValues, draftDataList)}
                                          >
                                            <option value={0}>
                                              -Select-
                                            </option>
                                            {item.radioCheckboxValue != null
                                              ? JSON.parse(
                                                item.radioCheckboxValue
                                              ).map((itemDropdown) => (
                                                <option
                                                  key={itemDropdown}
                                                  value={
                                                    itemDropdown
                                                  }
                                                >
                                                  {itemDropdown}
                                                </option>
                                              ))
                                              : ""}
                                          </select>
                                        )
                                          : item.fieldtype === "radio" ||
                                            item.fieldtype === "checkbox" ? (
                                            <>
                                              {item.radioCheckboxValue &&
                                                JSON.parse(
                                                  item.radioCheckboxValue
                                                ).map((radioData) => (
                                                  <React.Fragment key={radioData}>
                                                    <input
                                                      onChange={(e) =>
                                                        handleChange(e, item, index)
                                                      }
                                                      value={radioData}
                                                      type={item.fieldtype}
                                                      name={getFieldKey(item, index)}
                                                      data-field-id={item.id}
                                                      id={item.fieldName}
                                                    />{" "}
                                                    {radioData} <br />
                                                  </React.Fragment>
                                                ))}
                                              {item.dropDownFormData ? (
                                                <>
                                                  <div
                                                    style={{
                                                      border: "1px solid grey ",
                                                      padding: "15px",
                                                    }}
                                                  >
                                                    <Row className="mb-4">
                                                      {item.dropDownFormData
                                                        ? item.dropDownFormData.map(
                                                          (item) => (
                                                            <div className="col-md-6 mt-4">
                                                              <Form.Group
                                                                as={Col}
                                                                controlId="formGridEmail"
                                                              >
                                                                <Form.Label>
                                                                  {item.fieldtype !=
                                                                    "btn"
                                                                    ? item.fieldName
                                                                    : ""}
                                                                </Form.Label>{" "}
                                                                <br />
                                                                {item.fieldtype ==
                                                                  "select" ? (
                                                                  <select
                                                                    className="form-control"
                                                                    id={
                                                                      item.fieldName
                                                                    }
                                                                    name={item.id}
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      handleChangeForSubForm(
                                                                        e,
                                                                        item.formId,
                                                                        0
                                                                      )
                                                                    }
                                                                  >
                                                                    <option
                                                                      value={0}
                                                                    >
                                                                      Select
                                                                      Department
                                                                    </option>
                                                                    {item.dropdownValue !=
                                                                      null
                                                                      ? JSON.parse(
                                                                        item.dropdownValue
                                                                      ).map(
                                                                        (
                                                                          itemDropdown
                                                                        ) => (
                                                                          <>
                                                                            <option
                                                                              value={
                                                                                itemDropdown.fieldValue
                                                                              }
                                                                            >
                                                                              {
                                                                                itemDropdown.fieldValue
                                                                              }
                                                                            </option>
                                                                          </>
                                                                        )
                                                                      )
                                                                      : ""}
                                                                  </select>
                                                                ) : item.fieldtype ==
                                                                  "radio" ||
                                                                  item.fieldtype ==
                                                                  "checkbox" ? (
                                                                  JSON.parse(
                                                                    item.radioCheckboxValue
                                                                  ).map(
                                                                    (
                                                                      radioData
                                                                    ) => (
                                                                      <>
                                                                        <input
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handleChangeForSubForm(
                                                                              e,
                                                                              item.formId,
                                                                              0
                                                                            )
                                                                          }
                                                                          value={
                                                                            radioData
                                                                          }
                                                                          type={
                                                                            item.fieldtype
                                                                          }
                                                                          name={
                                                                            item.id
                                                                          }
                                                                          id={
                                                                            item.fieldName
                                                                          }
                                                                        />{" "}
                                                                        {
                                                                          radioData
                                                                        }{" "}
                                                                        <br />
                                                                      </>
                                                                    )
                                                                  )
                                                                ) : item.fieldtype ==
                                                                  "btn" ? (
                                                                  ""
                                                                ) : (
                                                                  <Form.Control
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      handleChangeForSubForm(
                                                                        e,
                                                                        item.formId,
                                                                        0
                                                                      )
                                                                    }
                                                                    required={
                                                                      item.isMandatory
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    type={
                                                                      item.fieldtype
                                                                    }
                                                                    name={item.id}
                                                                    placeholder={`Enter ${item.fieldName}`}
                                                                    id={
                                                                      item.fieldName
                                                                    }
                                                                    value={
                                                                      formValues[
                                                                      item?.id
                                                                      ]
                                                                    }
                                                                  />
                                                                )}
                                                              </Form.Group>
                                                            </div>
                                                          )
                                                        )
                                                        : ""}
                                                    </Row>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ) : item.fieldtype === "btn" ? (
                                            ""
                                          ) : item.fieldtype === "canvas" ? <>
                                            <MyKonvaComponent name={getFieldKey(item, index)} data-field-id={item.id} id={item.fieldName} imageUrl={item.fieldValue} height={400} width={700} stageRef={stageRefs[index]} index={index} handleSave={handleSave} />

                                          </> : (
                                            <Form.Control
                                              onChange={(e) => handleChange(e, item, index)}
                                              required={item.isMandatory ? true : false}
                                              type={item.fieldtype}
                                              name={getFieldKey(item, index)}
                                              data-field-id={item.id}
                                              value={item.fieldtype !== "file"
                                                ? (formId == 1 && item.fieldName == 'MRN Number'
                                                  ? MRNNumber
                                                  : getFieldValue(item, index, draftData, formValues, draftDataList))
                                                : undefined}
                                              placeholder={`Enter ${item.fieldName}`}
                                            />

                                          )}
                                    </Form.Group>
                                  )}
                                </Col>
                              )
                            )
                            : ""}

                          &nbsp;
                        </Row>

                        <br />
                        <br />
                        <button
                          className="btn btn-primary me-2"
                          onClick={formPreview}
                          type="submit"
                        >
                          Preview
                        </button>

                        {/* <button className="btn btn-primary me-2" onClick={(e) => handleSubmit(e, 0, 0)}>
                          Save Draft
                        </button> */}

                        <button className="btn btn-primary" onClick={(e) => resetForm(e)}>
                          Reset
                        </button>
                      </Form>
                    </>
                  ) : (
                    <FormPreview
                      formData={formPreviewValues}
                      onCancel={handleCancel}
                      onSubmit={handleSubmit}
                    />
                  )}
                </div>
              </Col>
            </Row>
            
            {/* Add Template Manager */}
            <Row>
              <Col>
                {formId && (
                  <FormTemplateManager 
                    formId={formId}
                    currentFormData={formValues}
                    onTemplateApply={handleTemplateApply}
                  />
                )}
              </Col>
            </Row>
            
            {/* Add Submission History */}
            <Row>
              <Col>
                {formId && patientId && (
                  <FormSubmissionHistory 
                    formId={formId}
                    patientId={patientId}
                    currentSubmissionId={null}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Webform;